export enum ActionType {
	INIT,
	PROCESS,
	END,
	DESTROY,
}
